import { connect } from 'react-redux';
import { checkRoles } from 'modules/auth';
import Advertiser from '../components/Advertiser';

const mapDispatchToProps = {
  checkRoles,
};

export default connect(null, mapDispatchToProps)(Advertiser);
